import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Package, GalleryHorizontal, PenSquare, Inbox, Activity } from "lucide-react";
import { adminApi } from "../api";

const CARDS = [
  { key: "destinations", label: "Destinations", icon: MapPin, to: "/admin/destinations", color: "text-blue-500 bg-blue-500/10" },
  { key: "packages", label: "Tour Packages", icon: Package, to: "/admin/packages", color: "text-amber-500 bg-amber-500/10" },
  { key: "gallery", label: "Gallery Images", icon: GalleryHorizontal, to: "/admin/gallery", color: "text-purple-500 bg-purple-500/10" },
  { key: "articles", label: "Blog Posts", icon: PenSquare, to: "/admin/blog", color: "text-emerald-500 bg-emerald-500/10" },
  { key: "enquiries", label: "Customer Enquiries", icon: Inbox, to: "/admin/enquiries", color: "text-rose-500 bg-rose-500/10" },
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminApi.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-dashboard-page">
      <h1 className="text-2xl font-bold mb-1">Dashboard</h1>
      <p className="text-sm text-muted-foreground mb-8">Overview of your website content and enquiries.</p>

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-10">
        {CARDS.map(({ key, label, icon: Icon, to, color }) => (
          <Link key={key} to={to} className="rounded-2xl border bg-white dark:bg-slate-900 p-5 hover:shadow-md hover:-translate-y-0.5 transition-all" data-testid={`stat-card-${key}`}>
            <span className={`h-10 w-10 rounded-xl grid place-items-center mb-3 ${color}`}><Icon className="h-5 w-5" /></span>
            <div className="text-3xl font-bold" data-testid={`stat-value-${key}`}>{stats ? stats[key] : "—"}</div>
            <div className="text-xs text-muted-foreground mt-1">{label}</div>
            {key === "enquiries" && stats?.new_enquiries > 0 && (
              <div className="text-[11px] text-rose-500 mt-1 font-medium">{stats.new_enquiries} new</div>
            )}
          </Link>
        ))}
      </div>

      <div className="rounded-2xl border bg-white dark:bg-slate-900 p-6" data-testid="recent-activity">
        <div className="flex items-center gap-2 mb-4">
          <Activity className="h-4 w-4 text-emerald-500" />
          <h2 className="font-semibold">Recent Activity</h2>
        </div>
        {!stats || stats.activity.length === 0 ? (
          <div className="text-sm text-muted-foreground py-6 text-center">No activity yet — changes you make will appear here.</div>
        ) : (
          <ul className="divide-y">
            {stats.activity.map((a, i) => (
              <li key={i} className="py-2.5 flex items-center justify-between gap-4 text-sm">
                <span>{a.message}</span>
                <span className="text-xs text-muted-foreground whitespace-nowrap">{new Date(a.at).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
